var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height align-start",attrs:{"id":"data-tables","fluid":"","tag":"section"}},[_c('v-container',{attrs:{"fluid":""}},[_c('ik-data-table',{attrs:{"entity-name":"TaxSetting","model":_vm.model,"use-delete-action":false,"icon":"mdi-cash-usd"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }